<template>
	<v-menu offset-y>
		<template v-slot:activator="{ on, attrs }">
			<v-btn id="transparent_btn" class="ma-0 pa-0 pl-2 pr-2" elevation="0"
				width="2.5rem" height="2rem" v-bind="attrs" v-on="on">
				<v-img height="2rem" width="2.5rem" class="ma-0 pa-0"
					src="@/assets/images/dots.png"></v-img>
			</v-btn>
		</template>
		<v-list class="ma-0 pa-0" dense>
			<v-list-item class="pa-4" @click="showUserDetail(user)">
				<v-list-item-title align="left">{{ t('detailView') }}</v-list-item-title>
			</v-list-item>
			<v-list-item class="pa-4" @click="deleteUser(user)">
				<v-list-item-title align="left">{{ t('delete') }}</v-list-item-title>
			</v-list-item>
		</v-list>
	</v-menu>
</template>

<script>
import mixin from '@/mixin';
export default {
	props: {
		user: { type: Object },
		type: { type: String },
	},
	components: {
		
	},
	mixins: [mixin.common],
	data: () => ({
		detailUser: {},
		userAuthorityDetail: {},
	}),
	methods: {
		showUserDetail(item) {
			this.$vloading.show();
      let params = {};
      this.networkController.getShareUserByUmid(params, item.umid)
      .then((res) => {
				console.log('%cUser Detail\n', "color:#008DD0;",res.data);
				if(this.type === 'admin') {
					this.detailUser = item;
					this.detailUser.status = res.data.accounts[0].status;
					this.detailUser.userLoginId = res.data.accounts[0].userName == undefined ? '' : res.data.accounts[0].userName;
          this.$vloading.hide();
          this.$emit('sendDetailUser', this.detailUser);
				} else if(this.type === 'normal') {
					this.userAuthorityDetail = item;
					this.userAuthorityDetail.status = res.data.accounts[0].status;
					this.userAuthorityDetail.userLoginId = res.data.accounts[0].userName;
					this.$emit('sendUserAuthorityDetail', this.userAuthorityDetail);
				} else if(this.type === 'group') {
					this.detailUser = item;
        	this.detailUser.userLoginId = res.data.accounts[0].userName == undefined ? '' : res.data.accounts[0].userName;
          this.$emit('sendDetailUser', this.detailUser);
				} else { // type = viewer
					this.detailUser = item;
					this.detailUser.userLoginId = res.data.accounts.length != 0 ? res.data.accounts[0].userName : '';
          this.$vloading.hide();
					this.$emit('sendDetailUser', this.detailUser);
				}
      }).catch(error => { this.$vloading.hide(); });
    },
		async deleteUser(user) {
			await this.$dialog.confirm({
				title: 'シェアユーザー削除',
				text: 'このユーザーはUSEN Cameraの利用が出来なくなりますが、ユーザーの削除を行いますか?',
				actions: {
					false: { color: 'white', text: 'キャンセル',},
					true: {
						color: '#008DD0', text: '削除する',
						handle: () => {
							this.$vloading.show();
							this.networkController.deleteShareUser({}, user.umid)
      				.then((res) => {
								console.log(res.data);
								this.$emit('deleteSuccess', true);
								this.$vloading.hide();
							}).catch(error => { 
								this.$emit('deleteSuccess', true);
								this.$vloading.hide(); 
							});
						}
					}
				}
			});
		},
	}
}
</script>

<style lang="scss" scoped>
#transparent_btn {
  background-color: transparent;
	min-width: 25px;
}
.v-list {
  background: #171921 !important;
	border: 1px solid #4A4A4A;
}
::v-deep {
  .v-list-item{
    min-height: 0px;
    color: white !important;
  }
  .v-list-item__content{
    color: white;
  }
}
</style>